import { REASONS_BLOCK } from 'modules/userManager/constants';

const { INAPPROPRIATE_BEHAVIOR, END_ACCESS_PERIOD, LATE_PAYMENT, OTHERS } =
  REASONS_BLOCK;

export const listReasonsBlocks = [
  {
    id: 0,
    label:
      'users_manager.deep_search.access.reasons_block.inappropriate_behavior',
    value: INAPPROPRIATE_BEHAVIOR
  },
  {
    id: 1,
    label: 'users_manager.deep_search.access.reasons_block.end_access_period',
    value: END_ACCESS_PERIOD
  },
  {
    id: 2,
    label: 'users_manager.deep_search.access.reasons_block.late_payment',
    value: LATE_PAYMENT
  },
  {
    id: 3,
    label: 'users_manager.deep_search.access.reasons_block.others',
    value: OTHERS
  }
];
